import dayjs from "dayjs";
import type {
	DynamicDateOption,
	DynamicTimeOption,
} from "../constants/dynamicForm.constant";

export function generateDynamicDate(option: DynamicDateOption): string {
	const now = dayjs();

	switch (option) {
		case "now":
			return now.toISOString();
		case "yesterday":
			return now.subtract(1, "day").toISOString();
		case "tomorrow":
			return now.add(1, "day").toISOString();
		case "next_week":
			return now.add(1, "week").toISOString();
		case "last_week":
			return now.subtract(1, "week").toISOString();
		case "one_month_ago":
			return now.subtract(1, "month").toISOString();
		case "one_month_from_now":
			return now.add(1, "month").toISOString();
		case "three_months_ago":
			return now.subtract(3, "month").toISOString();
		case "three_months_from_now":
			return now.add(3, "month").toISOString();
		case "six_months_ago":
			return now.subtract(6, "month").toISOString();
		case "six_months_from_now":
			return now.add(6, "month").toISOString();
		case "one_year_ago":
			return now.subtract(1, "year").toISOString();
		case "one_year_from_now":
			return now.add(1, "year").toISOString();
		case "start_of_day":
			return now.startOf("day").toISOString();
		case "end_of_day":
			return now.endOf("day").toISOString();
		case "start_of_week":
			return now.startOf("week").toISOString();
		case "end_of_week":
			return now.endOf("week").toISOString();
		case "start_of_month":
			return now.startOf("month").toISOString();
		case "end_of_month":
			return now.endOf("month").toISOString();
		case "start_of_year":
			return now.startOf("year").toISOString();
		case "end_of_year":
			return now.endOf("year").toISOString();
		default:
			return now.toISOString();
	}
}

export function generateDynamicTime(option: DynamicTimeOption): string {
	const now = dayjs();

	switch (option) {
		case "now":
			return now.toISOString();
		case "one_hour_ago":
			return now.subtract(1, "hour").toISOString();
		case "two_hours_ago":
			return now.subtract(2, "hour").toISOString();
		case "three_hours_ago":
			return now.subtract(3, "hour").toISOString();
		case "six_hours_ago":
			return now.subtract(6, "hour").toISOString();
		case "twelve_hours_ago":
			return now.subtract(12, "hour").toISOString();
		case "start_of_day":
			return now.startOf("day").toISOString();
		case "business_start":
			return now.startOf("day").add(9, "hour").toISOString(); // 9 AM
		case "lunch_start":
			return now.startOf("day").add(12, "hour").toISOString(); // 12 PM
		case "one_hour_from_now":
			return now.add(1, "hour").toISOString();
		case "two_hours_from_now":
			return now.add(2, "hour").toISOString();
		case "three_hours_from_now":
			return now.add(3, "hour").toISOString();
		case "six_hours_from_now":
			return now.add(6, "hour").toISOString();
		case "twelve_hours_from_now":
			return now.add(12, "hour").toISOString();
		case "end_of_day":
			return now.endOf("day").toISOString();
		case "business_end":
			return now.startOf("day").add(17, "hour").toISOString(); // 5 PM
		case "lunch_end":
			return now.startOf("day").add(13, "hour").toISOString(); // 1 PM
		default:
			return now.toISOString();
	}
}
